import React from 'react';
import cs from 'classnames';
import {reduxForm} from 'redux-form';
import {connect} from 'react-redux';

import * as modes from '~/modules/modal/modes';
import {modalChange} from '~/modules/modal/actions';
import {logIn} from '~/modules/user/actions';
import Button from '~/components/common/Button';
import LabeledInput from '~/components/common/LabeledInput';
import ErrorBlock from '../Error';
import FormHeader from '../FormHeader';
import mapDispatch from '~/misc/mapDispatch';
import {getQuery} from '~/misc/getQuery';
import authPageCSS from '~/components/authpage.css';
import sharedCSS from '~/components/shared.css';

const loginNavigate = ({login, password, nextAction}) => {
  if(!!getQuery(window.location.href).loginEmail) {
    return logIn({login, password, navigateUrl: '/account', nextAction})
  }
  return  logIn({login, password, nextAction})
}

const LoginForm = (props) => (
  <form data-qa='login-form'>
    <FormHeader context={""} defaultTitle='Log in'/>
    <div className={authPageCSS.inputs}>
      <LabeledInput
        autoFocus='true'
        mods={['wide', 'large']}
        label='Email'
        data-qa='email-input'
        {...props.fields.login}
      />
      <LabeledInput
        mods={['wide', 'large']}
        label='Password'
        type='password'
        data-qa='password-input'
        {...props.fields.password}
      />
    </div>
    <Button
      submit={true}
      mods={['wide', 'large', 'action']}
      onClick={!props.submitting && props.handleSubmit}
      data-qa='login-button'
    >
      {props.submitting ? '...' : 'Log in'}
    </Button>
    <ErrorBlock wrap={props.errorWrap}>{props.loginError}</ErrorBlock>
    <div className={authPageCSS.footLinks}>
      <span className={cs(sharedCSS.a, 'qa-forgot-link')} onClick={props.forgot}>Forgot password?</span>
      <span className={cs(sharedCSS.a, 'qa-signup-link')} onClick={() => props.anon ? props.signupV2() : props.signup()}>Sign up</span>
    </div>
  </form>
);

export default connect(
  ({user, window}) => ({loginError: user.loginError, anon: window.globalParams['anon'] === 'true'}),
  mapDispatch({
    onSubmit: (props, {login, password}) => loginNavigate({login, password, nextAction: props.context.nextAction}),
    forgot: () => modalChange(modes.RESET_PASSWORD, true),
    signup: (props) => modalChange(modes.SIGNUP, {
      nextAction: props.context.nextAction
    }),
    signupV2: () => modalChange(modes.SIGNUP_V2, true),
  })
)(reduxForm(
  {
    form: 'login',
    fields: ['login', 'password'],
  },
  (state, props) => ({
    initialValues: {login: getQuery(window.location.href).loginEmail}
  })
)(LoginForm));



// WEBPACK FOOTER //
// ./src/components/user/LoginForm/index.js